<template>
  <PC v-if="!isNemoApp"/>
  <H5 v-else/>
</template>
<script>
import PC from './pc'
import H5 from './h5'
export default {
  components: {
    PC,
    H5
  },
  provide() {
    return {
      from: this.from
    }
  },
  data() {
    return {
      from: { name: '' }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from.name = from.name
    })
  }
}
</script>
<style lang="scss" scoped>
</style>
